import React, { PureComponent, Fragment } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import Analytics from 'react-router-ga'

import bemClass from './utils/bemClass'
import { getAll } from './api'
import Header from './components/Header'
import Menu from './components/Menu'
import Footer from './components/Footer'
import Slider from './components/Slider'
import Loader from './components/Loader'
import Dummy from './components/Dummy'
import FrontPage from './components/FrontPage'
import InfoPage from './components/InfoPage'

import './App.css'

const cn = bemClass('App')

class App extends PureComponent {
    state = { loaded: false }

    getApi = async () => {
        await getAll()
        this.setState({ loaded: true })
    }

    componentWillMount() {
        this.getApi()
    }

    render() {
        const { loaded } = this.state

        return (
            <BrowserRouter>
                <Analytics id="UA-117059275-1">
                    <Fragment>
                        {loaded ? (
                            <div className={cn()}>
                                <Route component={Menu} />
                                <Header />
                                <Route path="/" exact component={Slider} />
                                <Switch>
                                    <Route path="/:site" component={InfoPage} />
                                    <Route path="/" component={FrontPage} />
                                </Switch>
                                <Footer />
                            </div>
                        ) : (
                            <Loader />
                        )}
                        <Dummy />
                    </Fragment>
                </Analytics>
            </BrowserRouter>
        )
    }
}

export default App



// WEBPACK FOOTER //
// ./src/App.jsx